<script setup lang="ts">
defineProps({
	width: {
		type: String,
		default: '46',
	},
	height: {
		type: String,
		default: '32',
	},
});
</script>
<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 58 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.5"
			y="0.5"
			width="57"
			height="39"
			rx="5.5"
			fill="white"
		/>
		<rect
			x="0.5"
			y="0.5"
			width="57"
			height="39"
			rx="5.5"
			stroke="#F2F4F7"
		/>
		<path
			d="M37 39L56 33.25V36C56 37.6569 54.6569 39 53 39H37Z"
			fill="#FD6020"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M48.9895 15.1847C50.7316 15.1847 51.6898 15.9906 51.6898 17.5129C51.7769 18.677 50.9929 19.662 49.9476 19.8411L52.2996 23.1542H50.4703L48.4668 19.9306H48.2926V23.1542H46.8118V15.1847H48.9895ZM48.2926 18.8561H48.7281C49.6863 18.8561 50.1218 18.4084 50.1218 17.6025C50.1218 16.8861 49.6863 16.4384 48.7281 16.4384H48.2926V18.8561ZM41.6724 23.1542H45.8536V21.8111H43.1533V19.662H45.7665V18.3188H43.1533V16.5279H45.8536V15.1847H41.6724V23.1542ZM37.317 20.5574L35.3135 15.1847H33.7456L36.9686 23.3333H37.7525L40.9755 15.1847H39.4076L37.317 20.5574ZM19.6341 19.2143C19.6341 21.4529 21.3763 23.3333 23.554 23.3333C24.2508 23.3333 24.8606 23.1542 25.4704 22.8856V21.0947C25.0348 21.632 24.4251 21.9902 23.7282 21.9902C22.3345 21.9902 21.2021 20.9156 21.2021 19.4829V19.3038C21.115 17.8711 22.2474 16.6175 23.6411 16.5279C24.3379 16.5279 25.0348 16.8861 25.4704 17.4234V15.6325C24.9477 15.2743 24.2508 15.1848 23.6411 15.1848C21.3763 15.0057 19.6341 16.8861 19.6341 19.2143ZM16.9338 18.2293C16.0627 17.8711 15.8014 17.692 15.8014 17.2443C15.8885 16.707 16.324 16.2593 16.8467 16.3488C17.2822 16.3488 17.7177 16.6175 18.0662 16.9756L18.8501 15.9011C18.2404 15.3638 17.4564 15.0057 16.6724 15.0057C15.4529 14.9161 14.4076 15.9011 14.3205 17.1547V17.2443C14.3205 18.3188 14.7561 18.9456 16.1498 19.3934C16.4982 19.4829 16.8467 19.662 17.1951 19.8411C17.4564 20.0202 17.6306 20.2888 17.6306 20.647C17.6306 21.2738 17.108 21.8111 16.5853 21.8111H16.4982C15.8014 21.8111 15.1916 21.3633 14.9303 20.7365L13.9721 21.7215C14.4948 22.7065 15.54 23.2438 16.5853 23.2438C17.9791 23.3333 19.1115 22.2588 19.1986 20.8261V20.5574C19.1115 19.4829 18.6759 18.9456 16.9338 18.2293ZM11.8815 23.1542H13.3623V15.1847H11.8815V23.1542ZM5 15.1848H7.1777H7.61324C9.70382 15.2743 11.3589 17.0652 11.2718 19.2143C11.2718 20.3784 10.7491 21.4529 9.87804 22.2588C9.09407 22.8856 8.13588 23.2438 7.1777 23.1543H5V15.1848ZM6.91638 21.8111C7.61324 21.9006 8.39721 21.632 8.91986 21.1842C9.4425 20.647 9.70383 19.9306 9.70383 19.1247C9.70383 18.4083 9.4425 17.692 8.91986 17.1547C8.39721 16.707 7.61324 16.4384 6.91638 16.5279H6.48084V21.8111H6.91638Z"
			fill="black"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M29.9132 15C27.7355 15 25.9062 16.7909 25.9062 19.1191C25.9062 21.3577 27.6484 23.2381 29.9132 23.3277C32.178 23.4172 33.9202 21.5368 34.0073 19.2086C33.9202 16.8804 32.178 15 29.9132 15V15Z"
			fill="#FD6020"
		/>
	</svg>
</template>
